import {
    ChangeDetectionStrategy,
    Component,
} from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

import { H2Component } from '~/app/shared/components/elements/h2/h2.component';
import { IconComponent } from '~/app/shared/components/elements/icon/icon.component';
import { LabelComponent } from '~/app/shared/components/elements/label/label.component';

@Component({
    selector: 'eb-help-contact-form-success',
    templateUrl: './help-contact-form-success.component.html',
    styleUrl: './help-contact-form-success.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        TranslocoModule,
        H2Component,
        IconComponent,
        LabelComponent,
    ],
})
export class HelpContactFormSuccessComponent {}
